export { default as BrandTypes } from "./brand-types.component";
export { default as BrandsSelector } from "./brands-selector.component";